import React from 'react'

export const formatRichText = (text?: string) => {
  if (text === undefined) return null

  return text.split('\n').map((line, index) => (
    <React.Fragment key={index}>
      {line}
      <br />
    </React.Fragment>
  ))
}